.overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	backdrop-filter: blur(2px);
}

.modal {
	background: white;
	border-radius: 8px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	width: 90%;
	max-width: 420px;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateY(-20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.header {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 16px;
	border-bottom: 1px solid #e5e7eb;
	position: relative;
}

.iconWrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background-color: #fef3c7;
	flex-shrink: 0;
}

.icon {
	color: #f59e0b;
	width: 20px;
	height: 20px;
}

.title {
	flex: 1;
	font-size: 1rem;
	font-weight: 600;
	color: #111827;
	margin: 0;
}

.closeButton {
	background: none;
	border: none;
	padding: 4px;
	cursor: pointer;
	color: #6b7280;
	border-radius: 4px;
	transition: all 0.15s ease;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: #f3f4f6;
		color: #111827;
	}
}

.content {
	padding: 16px;
	flex: 1;
	overflow-y: auto;
}

.message {
	font-size: 0.875rem;
	line-height: 1.5;
	color: #374151;
	margin: 0;
	white-space: pre-line;
}

.footer {
	display: flex;
	gap: 8px;
	padding: 12px 16px;
	border-top: 1px solid #e5e7eb;
	justify-content: flex-end;
}

.verificationWrapper {
	margin-top: 12px;
}

.verificationLabel {
	font-size: 0.8125rem;
	color: #374151;
	margin: 0 0 6px 0;
}

.verificationInput {
	width: 100%;
	padding: 7px 10px;
	font-size: 0.875rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	outline: none;
	transition: border-color 0.15s ease;
	box-sizing: border-box;

	&:focus {
		border-color: #6366f1;
		box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.15);
	}
}
